var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"select-vendors-completed"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('VendorBriefTableCompleted',{attrs:{"data":_vm.deliverVendorList}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }